import axios from "axios";
import { Person } from "./types";

const API_URL = "https://lukkypro.ru/api/v1/";

export const getUsers = async () => {
    const { data } = await axios.get<Person[]>(
        `${API_URL}users/get_user_list`,
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
        }
    );
    return data;
};